module.exports = __webpack_public_path__ + "static/media/04.15085c40.jpg";